import { render, staticRenderFns } from "./Recuperar.vue?vue&type=template&id=0c995d98&"
import script from "./Recuperar.vue?vue&type=script&lang=js&"
export * from "./Recuperar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports